<template>
  <div id="layout-sidenav" class="layout-sidenav-horizontal sidenav sidenav-horizontal flex-grow-0 container-p-x bg-white">
    <!-- Links -->
    <!--<a href="#" class="sidenav-horizontal-prev disabled"></a> -->
    <div class="sidenav-horizontal-wrapper">
      <ul class="sidenav-inner" style="margin-left: 0px;">
        <!-- Dashboards -->
        <li class="sidenav-item" :class="isDegreeProgressActive">
          <b-link @click="navigateToTab('degree')" class="sidenav-link">
            <i class="sidenav-icon far fa-comments d-block"></i> <div>Degree Progress</div>
          </b-link>
        </li>
        <li class="sidenav-item" :class="isCareerProgressActive">
          <b-link class="sidenav-link" @click="navigateToTab('career')">
            <i class="sidenav-icon fas fa-users d-block"></i> <div>Career Progresss</div>
          </b-link>
        </li>
      </ul>
    </div>
    <!-- <a href="#" class="sidenav-horizontal-next disabled"></a> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'secondaryNavbar',
  props: ['active'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
    navigateToTab (tab) {
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    isDegreeProgressActive () {
      if (this.active === 'degree') {
        return 'active'
      } else {
        return ''
      }
    },
    isCareerProgressActive () {
      if (this.active === 'career') {
        return 'active'
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/SecondaryNavbar.vue